<template>
    <div class="certifikat ovoj" id="html">


        <div id="prvi-del">


            <div class="glava mali-ovoj">

                <div class="levi-logo">
                    <img>
                </div>
                <div class="glava certifikat">
                    <div>
                        <img src="~@/assets/logo-fkbv.png" style="height: 100px;">

                        <img src="~@/assets/eko-logo.svg" style="height: 100px;margin-left:1rem;">
                    </div>
                   <!-- <h2 class="naslovinstitut">Inštitut za ekološko kmetijstvo</h2> -->
                </div>
                <div class="desni-logo">
                    
                </div>
            </div>

            <!--<div class="levi-stolpec">
      <div class="eko-napis">Ekološko kmetijstvo</div>
     </div>
   -->

            <!-- 1-4 -->
            <div class="celotna-sekcija">
                <h1 class="input-naslov" style="text-align: center;">POTRDILO O USTREZNOSTI PROIZVODOV ZA UPORABO V EKOLOŠKI PRIDELAVI</h1>
                <table class="osnovno">
                    <colgroup>
                        <col style="width:20%">
                        <col style="width:80%">
                    </colgroup>
                    <tr>
					    <td>Ponudnik</td>
					    <td>{{ input.imepodjetja }}</td>
				    </tr>
                    <tr>
					    <td>Naslov</td>
					    <td>{{ input.naslovponudnika }}</td>
				    </tr>
                    <tr>
					    <td>Ime in priimek odgovorne osebe</td>
					    <td>{{ input.odgovornaoseba }}</td>
				    </tr>
                    <tr>
					    <td>Potrdilo se izdaja za proizvod iz skupine: &raquo;{{ input.kategorije.filter(a=>a).join(", ") }}&laquo;</td>
					    <td>{{ input.trgovskoime }}</td>
				    </tr>
                </table>
                <div class="opomba1 besedilo">
                    {{ input.opomba1 }}
                </div>
                <table class="osnovno">
                    <colgroup>
                        <col style="width:20%">
                        <col style="width:80%">
                    </colgroup>
                    <tr>
					    <td>Obrazložitev</td>
					    <td>{{ input.opomba2 }}</td>
				    </tr>
                </table>
                    <table class="osnovno">
                    <colgroup>
                        <col style="width:20%">
                        <col style="width:80%">
                    </colgroup>
                    <tr>
					    <td>Opomba</td>
					    <td>UM Fakulteta za kmetijstvo in biosistemske vede, Inštitut za ekološko kmetijstvo ne prevzema odgovornosti za napačne navedbe na deklaracijah proizvodov, za nakdnadne spremembe sestavin in/ali proizvodnih postopkov ter za morebitno zavajajoče oglaševanje in/ali navodila za uporabo.</td>
				    </tr>
                    </table>

                    <div class="besedilo" style="margin-top:1rem">Številka potrdila: {{ input.stevilkapotrdila?input.stevilkapotrdila:input.id+"/2025" }}</div>
                    <div class="besedilo">Pivola {{ input.datumpotrdila?input.datumpotrdila:(new Date()).toLocaleDateString('sl-SI') }}</div>
                    <div class="besedilo desno" style="margin-top:1rem">UM Fakulteta za kmetijstvo in biosistemske vede,<br>Inštitut za ekološko kmetijstvo<br>red. prof. dr. Martina BAVEC</div>
                    <div class="desno"><img class="podpis" src="~@/assets/podpis-fkbv.png"></div>
            </div>
        </div>
        <div id="inputi-noga">
        Univerza v Mariboru, Fakulteta za kmetijstvo in biosistemske vede,<br>Inštitut za ekološko kmetijstvo, Pivola 10, 2311 Hoče
        </div>
    </div>
</template>
<script>





import { mapState, mapActions } from 'vuex'
import { inputService } from '../services/input.service';
import Vue from 'vue';

export default {
    props: ["inputid"],



    data: function () {
        return {
            input: {},

        }
    },
    computed: {
    },

    methods: {

    },
    created() {

        console.log("Page refresh, checking properties");
        console.log(this.inputid);


        inputService.vrniPoId(this.inputid).then(
            data => {
                //Vue.set(this, 'inputi', data.filter(d=>d.jeaktivna));
                Vue.set(this, 'input', data);

            },
            err => {
                console.log(err);
            }
        );



    },
    mounted() {

    }
}
</script>
<style scoped>
.input-naslov{
font-size: 16px;
}
#inputi-noga{
    margin-top:2rem;
    text-align: center;
}
.podpis{
    height: 50px;
}
.besedilo{
    font-size:16px;
}
.desno {
    text-align: right;
}
.osnovno{
     margin-top:1rem;
     font-size:16px;
     border-collapse: collapse;
     table-layout: fixed;
     width: 100%;
}
.osnovno td {
    padding: 4px;
    border: 1px solid black;
    border-collapse: collapse;
}
.naslovinstitut {
    font-size: 11px;
    font-weight: 600;
    color: #5386a3;

}

.certifikat.ovoj {
    margin: 0, auto, 0, auto
}

.seznam table {
    border-collapse: collapse;
}

.seznam .status {

    font-weight: bold;
    font-size: 1.0em;
    color: var(--accent);
}

.seznam td {
    border: 1px solid var(--accent);

    padding: 15px;
    text-align: left;

}

.naslov.certifikat {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 1.4em;
    text-decoration: none;
    margin-bottom: 3em;
}

.vrstica {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.naslov {
    font-size: 0.8em;
    text-decoration: underline;
}

.sekcija {
    margin-bottom: 2em;
}

.naziv-nosilca,
.naslov-nosilca {
    color: var(--accent);
    font-size: 1.2em;
    font-weight: bold;

}

.levi-logo {
    flex-grow: 1;
    height: 100%;
}

.desni-logo {
    flex-grow: 1;
    height: 100%;
}

.levi-logo img,
.desni-logo img {
    height: 8em;
    witdh: auto;
}


.certifikat.ovoj {

    width: 21cm;
    height: 29.7cm;
    margin: auto !important;
    /* change the margins as you want them to be. */
}

.certifikat.glava {
    justify-content: space-between;

}


.seznam-proizvodov thead td:nth-child(2) {
    w-idth: 100px;
}

.noga .sekcija {
    margin-bottom: 0;
}

.seznam table {
    border-collapse: collapse;
    width: 100%;
}

.naslov {
    margin-bottom: 1em;
}


.seznam tbody td.kategorija-naziv {
    background-color: var(--accent);
    color: white;
    font-weight: bold;

}

.seznam thead td,
td.kategorija-naziv {
    border-top: 1px solid var(--accent);
    border-right: 1px solid var(--accent);

}

.seznam td:nth-child(2) {

    border-right: 1px solid var(--accent);
}

.seznam td {
    -border: 1px solid var(--accent);
    border-left: 1px solid var(--accent);
    border-bottom: 1px solid var(--accent);
    padding: 0.5em;
    text-align: left;
    border-collapse: collapse;


}

.certifikat.ovoj h3 {
    font-size: 2em;
}


.no-wrap {
    white-space: nowrap;
}

.certifikat.ovoj {

    font-size: 3mm;
    color: #111;
    font-family: "Republika", arial, helvetica, sans-serif;
}

.glava.mali-ovoj {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.desni-logo {}

.levi-logo {}


.glava.certifikat {


    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 1em;
    text-decoration: none;
    justify-content: center;
    flex-grow: 1;
    margin-bottom: 2em;
    margin-top: 2em;

}

.glava.certifikat h1 {
    font-size: 9mm;
    margin: 0;
    letter-spacing: 4mm;
    line-height: 6mm;

}

.vrstica {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;

    margin-bottom: 1em;
}

.vrstica>div,
.seznam-informacij .vsebina-kategorije {
    border: 1px solid var(--accent);
    padding: 0.5em;
}

.vrstica>div:nth-child(1) {
    border-right: none;

}

.naslov {

    text-decoration: underline;
}

.sekcija {
    margin-bottom: 5mm;


}

.naziv-nosilca,
.naslov-nosilca,
.naziv-izvajalca,
.naslov-izvajalca,
.sifra-izvajalca,
.stevilka-certifikata>.stevilka-certifikata,
.dejavnosti-izvajalca li {
    color: var(--accent);
    font-size: 1.2em;
    font-weight: bold;

}

.seznam tbody td {
    color: var(--accent);
    font-weight: bold;
}


.certifikat.ovoj {
    /* change the margins as you want them to be. */

}
</style>
